import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";

const ResponseDetailsForm = ({}) =>{
    return(
        <>
        <StyledSectionHeading>
            <span>Request Information</span>
        </StyledSectionHeading>
        
        <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
               <FormItem label="Is Error">
                 <TextField/>
               </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={8}>
               <FormItem label="Date Received">
                 <CommonDatePicker 
                 placeholder="MM/DD/YYYY"
                 format="MM/DD/YYYY" 
                 showTime={false} 
                 />
               </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={8}>
               <FormItem label="Time Received">
                 <TimePicker/>
               </FormItem>
            </StyledGridCol>
            <StyledGridCol xs={24} lg={24}>
               <FormItem label="Response">
                 <TextField inputType="textarea" rows="5"/>
               </FormItem>
            </StyledGridCol>
        </StyledGridRow>
        
        </>
    )
}
export default ResponseDetailsForm;